import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createArchive } from "../../../api/homepageManagementStudyArchive.api";
import ErrorResponse from "../../../components/ErrorResponse";
import ArchiveEditor from "../../../components/homepage/archive/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const ArchiveCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/homepage/archive');
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createArchive(data));
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.archive.title2')}
      />
      <ArchiveEditor
        submit={submit}
      />
    </div>
  );
}

export default ArchiveCreate;